import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";
import MaterialIcon from "./MaterialIcon";

export const BackButton: React.FC<{
  cssStyle?: ThemeUIStyleObject;
  onClick: () => void;
}> = ({ cssStyle, onClick }) => {
  return (
    <a data-name="back_button:material_icon" sx={{ ...backButtonStyle, ...cssStyle }} onClick={onClick}>
      <MaterialIcon icon="arrow_back" />
    </a>
  );
};

const backButtonStyle: ThemeUIStyleObject = {
  display: "block",
  position: "absolute",
  top: 0,
  left: 0,
  fontSize: "24px",
  cursor: "pointer",
};
